var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 5,
    height: 21,
    viewBox: "0 0 5 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 21,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192",
    transform: "translate(-451 -332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_3",
    "data-name": "Repeat Grid 3",
    transform: "translate(451 332)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-525 -325)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(525 325)",
    fill: "#7e7e7e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-525 -317)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44-2",
    "data-name": "Ellipse 44",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(525 325)",
    fill: "#7e7e7e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-525 -309)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44-3",
    "data-name": "Ellipse 44",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(525 325)",
    fill: "#7e7e7e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerIcon);
export default __webpack_public_path__ + "static/media/burger-icon.b9bfffec592b7014e63a226f9aa1422d.svg";
export { ForwardRef as ReactComponent };